module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('article', {
    staticClass: "container"
  }, [_h('div', {
    staticClass: "cover",
    style: ({
      backgroundImage: 'url(' + _vm.imagePath + ')'
    }),
    attrs: {
      "alt": _vm.title
    }
  }), " ", _h('div', {
    staticClass: "description"
  }, [_h('div', {
    staticClass: "title"
  }, [_vm._s(_vm.title)]), " ", _h('div', {
    staticClass: "subtitle"
  }, [_vm._s(_vm.subtitle)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-67efae1d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Card.vue
// module id = 54
// module chunks = 1